module.exports = __webpack_public_path__ + "img/offer.a8227c54.jpg";